import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import styles from "./reg.module.css";

const Register = () => {
  const navigate = useNavigate(); 
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    phoneNumber: "",
    state: "",
    city: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let formErrors = {};

    if (!formData.firstName) formErrors.firstName = "एरर*";
    if (!formData.lastName) formErrors.lastName = "एरर*";
    if (!formData.gender) formErrors.gender = "एरर*";
    if (!formData.phoneNumber) formErrors.phoneNumber = "एरर*";
    if (!formData.state) formErrors.state = "एरर*";
    if (!formData.city) formErrors.city = "एरर*";

    setErrors(formErrors);

    return Object.keys(formErrors).length === 0;

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      alert("कृपया सर्व आवश्यक जागा भरा");
    } else  {
      try {
        const response = await axios.post("https://selfie.meghnabordikar.com/auth/register", formData);
        if (response.status === 201) {
          setSuccessMessage("Registration successful!");
          console.log("Registration successful!")
          setFormData({
            firstName: "",
            lastName: "",
            gender: "",
            phoneNumber: "",
            state: "",
            city: "",
          });
        }
        navigate("/selfie")
      } catch (error) {
        console.error("Error submitting the form:", error);
        alert("Failed to register. Please try again.");
      }
    }
  };

  return (
    <div className={styles.formContainer}>
      <h1 className={styles.formTitle}>देउन दीदी ना साथ,  करू विकासाची सुरवात</h1>
      {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label>
            नाव <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Ram"
          />
          {errors.firstName && <span className={styles.error}>{errors.firstName}</span>}
        </div>
        <div className={styles.formGroup}>
          <label>
            आडनाव <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Shah"
          />
          {errors.lastName && <span className={styles.error}>{errors.lastName}</span>}
        </div>
        <div className={styles.formGroup}>
          <label>
            लिंग <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            placeholder="Male"
          />
          {errors.gender && <span className={styles.error}>{errors.gender}</span>}
        </div>
        <div className={styles.formGroup}>
          <label>
          मोबाईल नंबर <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="82903XXXXX"
          />
          {errors.phoneNumber && (
            <span className={styles.error}>{errors.phoneNumber}</span>
          )}
        </div>
        <div className={styles.formGroup}>
          <label>
            राज्य <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            placeholder="Maharashtra"
          />
          {errors.state && <span className={styles.error}>{errors.state}</span>}
        </div>
        <div className={styles.formGroup}>
          <label>
            शहर <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Mumbai"
          />
          {errors.city && <span className={styles.error}>{errors.city}</span>}
        </div>
        <button type="submit" className={styles.submitButton}>
          Submit
        </button>
      </form>
    </div>
  );
};

export default Register;
